export default {
      id: "ar_brochures-usage",
      viewBox: "0 0 110 100",
      url: "../dist/images/" + "sprite.svg#ar_brochures-usage",
      toString: function () {
        return this.url;
      }
    }